import LayoutNode, { getNodeComponentAttributeValue, getNodeStyleAttributeValue, setNodeComponentAttributeValue, setNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { SiteData } from "../Data/SiteData";
import { UserContext } from "vagaro-website-rendering/src/components/Definitions/UserContext";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import { GetWBComponentByTypename } from "../Data/WBData";
import { CreateBlankLayoutNode } from "../WBCanvas";
import React from "react";
import { DownCaret } from "../Icons/Carets";
import { CheckItem } from "../StyleInputs/CategorySelector";

import HamburgerIcon from "vagaro-website-rendering/src/components/Icons/Hamburger";
import { LoginUserType } from "utils/Utils";
import { AlertConfirm, Confirmation } from "../ConfirmationPopups";
import Loader from "components/Common/Loader";
import { ChangeCategorySequence, ChangeSectionSequence, DeleteSection, DuplicateSection, GetSectionCategories, GetSectionList, SetSectionPrivateOrPublic } from "../Utilities/SectionTemplateAPI";
import { OpenSaveAsSectionMenu, SectionSaveType } from "./SaveSectionMenu";
import { componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import fadeInElement from "../Utilities/ElementAnimator";

export const ShowSectionTemplatesToBusinessUsers = true;
const showFiltersInBusinessPage = true;
const templateScale = .33;
const templateBreakPoint = 1200;


enum TemplateState{
  Normal = 0,
  Edit = 1,
  DragOrder = 2,
}

type TemplateDefinition = {
  id:string,
  content:string,
  rank:number,
  isPrivate?:boolean,
  categoryID:string[],
}

type CategoryDefinition = {
  id:string,
  name:string,
  rank:number
}

 const customSaveCategory = "My Sections";
 const allCategory = "All";
 const unCatergorizedCategory = "No Category";

//calcualted const for scaling templates (based of of template scaled do not touch)
const widthPerc = (1/templateScale)*100+"%";
const leftPerc = ((1-templateScale)/2)/templateScale*-100+"%";

type TemplateParams = {
  selected:string,
  state:TemplateState,
  setSelected:(val:string)=>void,
  setState:(val:TemplateState)=>void,
  allTemplates:TemplateDefinition[],
  setTemplates:(val:TemplateDefinition[])=>void,
  setCategory:(val:string)=>void,
  setCategories:(val:CategoryDefinition[])=>void,
  mouseX:number,
  mouseY:number,
  showPublic:boolean,
  showPrivate:boolean,
  userContext:UserContext,
  category:string,
  categories:CategoryDefinition[],
  isAdmin:boolean,
  isAdminSite:boolean,
  deleteTemplate:(id:string)=>void,
  reload:Function
  setIsLoading:(val:boolean)=>void,
 
}
 
const showGhostSection  = true;
const previewHeightWhenDragging = false;

export default function SectionTemplateMenu({
  siteData,
  onDismiss,
  onSelect,
}: {
  siteData: SiteData,
  onDismiss:Function,
  onSelect?:(node:LayoutNode)=>void
}) {

  const isAdmin =  siteData.userContext.userType === LoginUserType.VagaroAdmin &&(showFiltersInBusinessPage||siteData.userContext.isAdmin);

  const [secTemplates,setTemplates]             = useState<TemplateDefinition[]>([]);
  const [showPublic,setShowPublic]              = useState(true);
  const [showPrivate,setShowPrivate]            = useState(true);
  const [filterOpen,setFilterOpen]              = useState(false);
  const [templateState,setTemplateState]        = useState(TemplateState.Normal);
  const [selectedTemplate,setSelectedTemplate]  = useState<string>("");
  const [mousePos,setMousePos]                  = useState({x:0,y:0});
  const containerRef                            = useRef<HTMLDivElement>(null);
  const [category,setCategory]                  = useState("");
  const [categories,setCategories]              = useState<CategoryDefinition[]>([]);
  const [isLoading,setIsLoading]                = useState(true);
  const insertIndex                             = useRef<number>(-1);
  //passing through all the states and functions was a nightmare so pass an object instead

  const loadAll = (reloadSections:boolean = true)=>{

    setIsLoading(true);
    GetSectionCategories(siteData.userContext,(data:any)=>{

      data = data.sort((a:CategoryDefinition,b:CategoryDefinition)=>a.rank-b.rank);

      setCategories(data);
    
      params.current.categories = data;

      if(reloadSections)
        loadAllTemplates();
      else
        setIsLoading(false);

      if(data.length>0){
        let current = params.current.category;

      
        if(current.length < 2 && params.current.categories.length>0){ // initialize first cat
          params.current.category = params.current.categories[0].id;
          params.current.setCategory(params.current.categories[0].id);
          fadeInTemplates();
        }
      }
 
    },(error:any)=>{

      setIsLoading(false);
      console.error(error);
      AlertConfirm("Error loading categories");

    });
  }

  const params = useRef<TemplateParams>({
    selected: selectedTemplate,
    state: templateState,
    setSelected: (val:string)=>{setSelectedTemplate(val)},
    setState: (val:TemplateState)=>{setTemplateState(val)},
    allTemplates: [],
    setTemplates: (val:TemplateDefinition[])=>{setTemplates(val)},
    setCategory: (val:string)=>{setCategory(val)},
    mouseX: mousePos.x,
    mouseY: mousePos.y,
    showPublic:showPublic,
    showPrivate:showPrivate,
    category:"",
    categories:[],
    userContext:siteData.userContext,
    isAdmin:isAdmin,
    isAdminSite:siteData.userContext.isAdmin??false,
    setCategories:(val:CategoryDefinition[])=>{setCategories(val)},
    deleteTemplate:(id:string)=>{tryDeleteSectionTemplate(id)},
    reload:loadAll,
    setIsLoading(val) {
      setIsLoading(val);
    },


  });

  params.current.selected = selectedTemplate;
  params.current.state = templateState;
  params.current.mouseX = mousePos.x;
  params.current.mouseY = mousePos.y;
  params.current.category = category;

  const handleDragging = ()=>{

    if(TemplateState.DragOrder!== params.current.state)
      return;

    if(!containerRef.current)
      return;

    let current = params.current.allTemplates.findIndex((val)=>val.id===params.current.selected);
    if(current<0){

      return;
    }
 
    let doms = containerRef.current.querySelectorAll(".template-drop-point");
    let closestDistance = 100000;
    let closestDom = null;

    let draggedDom = document.getElementById(params.current.selected);

    let height = (draggedDom&&previewHeightWhenDragging)?(draggedDom as HTMLElement).offsetHeight:12;

    for(let i = 0;i<doms.length;i++){

      let dom = doms[i];
  
      (dom as any).style.height = "0px";
 
      let rect = dom.getBoundingClientRect();
      let centerY = rect.top+rect.height/2;
      let centerX = rect.left+rect.width/2;

      let distance = Math.sqrt(Math.pow(params.current.mouseX-centerX,2)+Math.pow(params.current.mouseY-centerY,2));
      if(distance<closestDistance){
        closestDistance = distance;
        closestDom = dom;
      }
      
    }

    if(closestDom!=null){
 
      let insert = parseInt(closestDom.getAttribute("datainsert")??"-1");
      (closestDom as any).style.height =  height+"px";
      if(insertIndex.current !== insert){
        insertIndex.current = insert;
      }

    }
  }

  const  loadAllTemplates = ()=>{

    setIsLoading(true);

    GetSectionList(siteData.userContext,"",
    
    (data:any)=>{

      let sortedData = (data as TemplateDefinition[]).sort((a,b)=>a.rank-b.rank);


 
      if(!params.current.isAdmin){ // never show private sections to users
        sortedData = sortedData.filter((val)=>!val.isPrivate);


        //removed unsused categories for user
        let cats:string[] = [];

        for(let i = 0;i<sortedData.length;i++){
          for(let j = 0;j<sortedData[i].categoryID.length;j++){
            if(!cats.includes(sortedData[i].categoryID[j])){
              cats.push(sortedData[i].categoryID[j]);
            }
          }

        }

        let filteredCats = params.current.categories.filter((val)=>cats.includes(val.id));
        params.current.setCategories(filteredCats);
        params.current.categories = filteredCats;

        if(params.current.categories.findIndex((a)=>a.id===params.current.category)<0){
          params.current.category = params.current.categories[0].id;
          params.current.setCategory(params.current.categories[0].id);
          fadeInTemplates();
        }
        

      }

      setTemplates(sortedData);
      params.current.allTemplates = sortedData;
      setIsLoading(false);
  
  
    },(error:any)=>{
      setIsLoading(false);
      console.error(error);
      AlertConfirm("Error loading sections");
    });

  }



  const tryDeleteSectionTemplate = (id:string)=>{
    setIsLoading(true);
    DeleteSection(siteData.userContext,id,
      (data:any)=>{
     
      loadAllTemplates();
      },
      (error:any)=>{
      AlertConfirm("Error deleting section template");
      setIsLoading(false);
    })
  }

  useEffect(() => {

    loadAll();
//eslint-disable-next-line
  },[]);

  const templateDefFromSaved =()=>{

    let temps:TemplateDefinition[] = [];
    let saved = siteData.savedSections;

    for(let i = 0;i<saved.length;i++){
      let newDef:TemplateDefinition = {id:i.toString()+"-save",content:saved[i],rank:i,isPrivate:false,categoryID:[customSaveCategory]}
      temps.push(newDef);
    }

    return temps;
  }


  const endDrag = (insert:number)=>{

    let prev = [...params.current.allTemplates]

    let current = params.current.allTemplates.findIndex((val)=>val.id===params.current.selected);

    let def = params.current.allTemplates[current];

    if(current<0||insert == current||insert<0)
    return;

    if(insert>current)
      insert--;

  

    params.current.setIsLoading(true);

    ChangeSectionSequence(params.current.userContext,def.id,def.rank,params.current.allTemplates[insert].rank,(data:any)=>{
      params.current.reload();

    },(error:any)=>{AlertConfirm("Error changing section order"); params.current.setIsLoading(false);
  
    params.current.setTemplates(prev);
    params.current.allTemplates = prev;
  });
    // for(let i = 0;i< params.current.allTemplates.length;i++){
      
    //   if( params.current.allTemplates[i])
    //   params.current.allTemplates[i].rank = i;
    
    // }
    let temp =  params.current.allTemplates[current];

 
    params.current.allTemplates.splice(current,1);
    params.current.allTemplates.splice(insert,0,temp);

    setTemplates([...params.current.allTemplates]);
  }


  const gapSize = 18;

  const onMouseMove = (e:any)=>{

    if(isAdmin)
      setMousePos({x:e.clientX,y:e.clientY});
 
      handleDragging();
  }

  const mouseUp = (e:any)=>{

    if(params.current.state === TemplateState.DragOrder){

      endDrag(insertIndex.current);
      setTemplateState(TemplateState.Normal);
      params.current.state = TemplateState.Normal;
      params.current.selected = "";
      setSelectedTemplate("");

    }
  }

  useEffect(() => {

    window.addEventListener("pointermove",onMouseMove);
    window.addEventListener("pointerup",mouseUp);

    return () => {
      window.removeEventListener("pointermove",onMouseMove);
      window.removeEventListener("pointerup",mouseUp);
    }
  //eslint-disable-next-line
  },[]);

  const getUncategorized = ()=>{
    let ids = categories.map((val)=>val.id);
    let unCatergorized = secTemplates.filter((val)=>{
  
        if(val.categoryID.length==0)
          return true;
  
        for(let i = 0;i<val.categoryID.length;i++){
          if(ids.includes(val.categoryID[i]))
            return false;
        }
  
        return true;
    });

    return unCatergorized;

  }


  let filteredTemps = (params.current.category===customSaveCategory)?
  templateDefFromSaved():
  params.current.category === unCatergorizedCategory?
    getUncategorized().filter((val)=>{

      if(!showPublic&&!val.isPrivate)
        return false;
      if(!showPrivate&&val.isPrivate)
        return false;
      return true;
    }):

   secTemplates.filter((val)=>{
    if(params.current.category !== allCategory&&!val.categoryID.includes(params.current.category))
      return false;

    if(!showPublic&&!val.isPrivate)
      return false;
    if(!showPrivate&&val.isPrivate)
      return false;
    return true;

  })

  return (
    <div className="center-all fast-fade" style={{position:"fixed",left:0,top:0,height:"100%",width:"100%",background:"#00000044",zIndex:3000}}>
      <style>
        {`
        .template-width{
          width:50%;
        }

        @media (max-width: ${templateBreakPoint}px) {

          .template-width{
            width:100%;
          }
        }
        `
        }
      </style>
      {isLoading&&<Loader/>}
      <div className="relative flex-column" style={{overflow:"hidden", padding:"8px 0px 0px 0px ",height:"100vh",width:"80vw", maxWidth:"1500px",maxHeight:"85vh",background:"white",borderRadius:"8px",boxShadow:"0 3px 20px 10px #00000044"}}>
      <div className="font-bold " style={{fontSize:"24px",padding:"0px 8px 16px 16px"}}>Sections</div>

       <div className="flex-row h-full" style={{overflow:"auto",paddingLeft:"8px"}} >
          <SectionCategoryList params={params.current} onSelect={onSelect} />

         
          <div ref={containerRef} id='template-container' className="flex-row w-full h-full v-site scrollable justify-start align-start" style={{overflowX:"hidden",background:"white",gap:gapSize+"px",padding:"0 "}}>
        { filteredTemps.length>0?
                
                  <SectionColumns setMousePos={setMousePos} templateParams={params.current} onSelect={onSelect} templates={filteredTemps} isAdmin={isAdmin} siteData={siteData} gapSize={gapSize} key={params.current.category} />
                  :
              <> {!isLoading &&
                <div className="center-all w-full h-full"><div style={{fontFamily: 'proxima-nova' }}>
                  <div className="font-bold flex-column align-center">No Sections Found</div> 
                  {params.current.category === customSaveCategory&&<div  style={{fontSize:".8em"}}>Your saved sections will show up here</div>}
                </div>
                </div>
              }
                </>
        }
        </div>
      </div>
      {isAdmin?
      <AdminFilterTab showPublic={showPublic} showPrivate={showPrivate} setShowPublic={ (val:boolean)=>{setShowPublic(val); params.current.showPublic = val}} setShowPrivate={ (val:boolean)=>{setShowPrivate(val); params.current.showPrivate = val}} filterOpen={filterOpen} setFilterOpen={setFilterOpen}   />:
      <button onClick={()=>{onDismiss&&onDismiss()}} className="invisible-button center-all font-bold" style={{fontFamily:"'proxima-nova'",width:"32px",height:"32px",color:"#333",background:"white",zIndex:"225",fontSize:"2em", position:"absolute",right:"8px",top:"14px"}}>&times;</button>
       
      }
       
      <div className="flex-row justify-end" style={{padding:"16px 20px",flexGrow:"0",boxShadow:"0 8px 20px 5px #00000022",zIndex:1}}>
        <button className="w-button w-button-secondary" 
        onClick={()=>{onDismiss&&onDismiss()}}
        >Cancel</button>
        </div>
    </div>
    </div>
  );
}

function fadeInTemplates(){

  let container = document.getElementById("template-container");

  if(container)
    fadeInElement(container,450);

}

function SectionDropPoint({insertAt}:{insertAt:number}){

  return <div {...{datainsert:insertAt}} className="template-drop-point center-all font-large template-width" style={{overflow:"hidden", transition:".2s",fontFamily:"monospace",  height:"0",background:"none",borderRadius:"4px",transform:"scaleX(.6)" }}></div>
}

function SectionColumns({templates,gapSize,siteData,isAdmin,onSelect,templateParams,setMousePos}:{setMousePos:Function,isAdmin:boolean,templates:TemplateDefinition[],gapSize:number,siteData:SiteData,onSelect?:(node:LayoutNode)=>void,templateParams:TemplateParams}){

  const inTemplates = templates;

  const [height,setHeight] = useState(5000);
  const colRef = useRef<HTMLDivElement>(null);



  const updateHeights  = ()=>{

    if(window.innerWidth<templateBreakPoint){
      if(height!==99999)
        setHeight(99999);
      return;
    }


    if(colRef.current){

      let queryString = (previewHeightWhenDragging)? ".sec-temp-container, .template-drop-point":".sec-temp-container"
      const children = colRef.current.querySelectorAll(queryString)
   
      let tracked = 0;
      let maxHeight = 0;

      let heightList = [];

      for(let i = 0;i<children.length;i++){
        if((children[i] as any).style.position === "fixed")
          continue;

        let h = (children[i] as HTMLElement).offsetHeight;


        tracked+=h;

        heightList.push(h);

        if(h > maxHeight)
          maxHeight = h;
      }

      let minHieght = children.length*(gapSize/2)

      let newHeight = Math.max( tracked/2,minHieght);

      let newTrack = 0;

      for(let i = 0;i<heightList.length;i++){
        newTrack+=heightList[i];
        if(newTrack>newHeight){
         
          let leftHeight = newTrack+gapSize;
          let rightHeight = (tracked-newTrack )+heightList[i];

          newHeight = Math.min(leftHeight,rightHeight)+gapSize;
          break;
        }

      }


      setHeight(newHeight+32)//+32 to compensate for bottom padding

     
    }
  }


  useEffect(() => {

    const resizeObserver = new ResizeObserver((entries) => {

      window.requestAnimationFrame(updateHeights);
    });

    if(colRef.current){
      resizeObserver.observe(colRef.current!);
    }
    updateHeights();
    return () => {resizeObserver.disconnect()}


//eslint-disable-next-line
  },[])




  return <div ref={colRef} className="w-full flex-column justify-start  align-start" style={{gap:"0",maxHeight:height+"px",flexWrap:"wrap",marginTop:"-12px",paddingBottom:"32px"}}>
      {templateParams.state==TemplateState.DragOrder&&<SectionDropPoint insertAt={0}/>}
      {inTemplates.map((comp, i) => {
        let index = templateParams.allTemplates.indexOf(comp);
        let padding = comp.id==templateParams.selected && templateParams.state === TemplateState.DragOrder?gapSize:gapSize;

        return <Fragment key = {i}>
        
             <div className="sec-temp-container template-width" style={{padding:padding}}><RenderSectionFromTemplate setMousePos={setMousePos}  templateParams={templateParams} index = {i} siteData={siteData} isAdmin={isAdmin} key={comp.id} definition={comp} userContext={siteData.userContext} onSelect={onSelect} /></div>
     
             {templateParams.state==TemplateState.DragOrder&& <SectionDropPoint insertAt={index+1}/> }
            </Fragment>
    })}
  </div>
}
function RenderSectionFromTemplate({isAdmin,definition,siteData,userContext,onSelect,index,templateParams,setMousePos}:{ setMousePos:Function,isAdmin:boolean,definition:TemplateDefinition,siteData:SiteData,userContext:UserContext,onSelect?:(node:LayoutNode)=>void,index:number,templateParams:TemplateParams}){

  let node = useMemo(()=>{

   let n = definition.content.startsWith("J")?CreateBlankLayoutNode(wBComponentTypeNames.section): JSON.parse(definition.content) as LayoutNode;

    n.id = definition.id;

    return n;

  },[definition.content]);
  const menuRef = useRef<HTMLDivElement>(null);

  const clickOutside = (e:any)=>{

    if(menuRef.current){
      if(!menuRef.current.contains(e.target)){
          templateParams.setState(TemplateState.Normal);
      } 
    }
  }

  const forceClose = ()=>{

    templateParams.setState(TemplateState.Normal);

  }

  const isOpen = templateParams.selected==definition.id&&templateParams.state==TemplateState.Edit;

  useEffect(() => {
    document.addEventListener("click",clickOutside);

    return () => {
      document.removeEventListener("click",clickOutside);

    }
//eslint-disable-next-line
  }, [])
  
  let extraStyling = {};

  const onDelete = ()=>{
    let index = templateParams.allTemplates.findIndex((val)=>val.id===definition.id);
    if(index>=0){
      Confirmation("Are you sure you want to delete this section template?",()=>{
        templateParams.deleteTemplate(definition.id);

      },undefined,"deleteSectionTemplate","Delete Section Template","Delete","Cancel");

    }
  }

  const onDeleteUserTemplate = ()=>{

    Confirmation("Are you sure you want to delete this section template?",()=>{

    let index = siteData.savedSections.findIndex((val)=>val===definition.content);
    if(index>=0){
      siteData.savedSections.splice(index,1);
    }

    templateParams.setCategories([...templateParams.categories]);
  },undefined,"deleteSectionTemplate","Delete Section Template","Delete","Cancel");


  }

  const duplicate = ()=>{
    templateParams.setIsLoading(true);

    DuplicateSection(siteData.userContext,definition.id,(data:any)=>{
      templateParams.reload();
      templateParams.setIsLoading(false);
      forceClose();
    },(error:any)=>{
      AlertConfirm("Error duplicating section");
      templateParams.setIsLoading(false);
      forceClose();
    });

  }

  const togglePrivate = ()=>{
    
    
    let toggle = !definition.isPrivate;
    templateParams.setIsLoading(true);
    SetSectionPrivateOrPublic(toggle,siteData.userContext,definition.id,(data:any)=>{

    let index = templateParams.allTemplates.findIndex((val)=>val.id===definition.id);
    if(index>=0){
      templateParams.allTemplates[index].isPrivate = !templateParams.allTemplates[index].isPrivate;
     
      templateParams.setTemplates([...templateParams.allTemplates]);

    }
    templateParams.setIsLoading(false);
    forceClose();
  },(error:any)=>{
    AlertConfirm("Error setting section to "+(toggle?"private":"public"));
    templateParams.setIsLoading(false);
    forceClose();
  });
 
     

  }

  const delayedClose = ()=>{
    setTimeout(() => {    forceClose();}, 0)
  }

  if(templateParams.selected === definition.id && templateParams.state === TemplateState.DragOrder ){
    
    extraStyling = {
      opacity:".4",
      position:"fixed",
      left:templateParams.mouseX-22+"px",
      top:templateParams.mouseY-22+"px",
      maxWidth: "calc(40vw - 136px)",
      zIndex: 160,
    

    }

  }

  return<>
    {
    templateParams.selected == definition.id && templateParams.state== TemplateState.DragOrder&& showGhostSection &&
      <RenderSectionTemplate key={node.id+" D"} definition={definition} extraStyling={{opacity:".25",outline:"1px dashed black"}} siteData={siteData} node={node} userContext={userContext} onSelect={onSelect}  ></RenderSectionTemplate>
    }
  
   <RenderSectionTemplate  key={node.id} definition={definition} extraStyling={extraStyling} siteData={siteData} node={node} userContext={userContext} onSelect={onSelect}  >
    {isAdmin&&templateParams.category!=customSaveCategory&&  (templateParams.state!= TemplateState.DragOrder||templateParams.selected===definition.id)&& <>
    <div className={"flex-row justify-between w-full template-hover-menu"+(isOpen?" selected":"") } style={{position:"absolute" ,top:"0px",left:"0px",zIndex:180-index}}>
      <button className="invisible-button"
      style={{cursor:"move"}}
       onClick={(e)=>{e.preventDefault();e.stopPropagation();}}
       onMouseDown={(e)=>{

        e.preventDefault();e.stopPropagation(); templateParams.setSelected(definition.id);templateParams.selected = definition.id;  templateParams.setState(TemplateState.DragOrder );
        if(isAdmin)
          setMousePos({x:e.clientX,y:e.clientY});
      
      }}
      >
        <HamburgerIconOutlined/>
      </button>
      <button style={{padding:"0px 6px"}} className="invisible-button relative"
      onClick={(e)=>{e.preventDefault();e.stopPropagation(); 
        
          templateParams.setSelected(definition.id);
          templateParams.setState(TemplateState.Edit);
       }}
      >
        <MenuDots/>
{
  isOpen&&
  <div className="flex-column" ref={menuRef} style={{fontFamily:"proxima-nova",position:"absolute",top:"100%",right:"0px",whiteSpace:"nowrap",zIndex:"10",background:"white",borderRadius:"4px",boxShadow:"rgba(0, 0, 0, 0.02) 0px 0px 10px 10px",padding:"4px 0px"}}>
    <button className="publish-button nested"
    onClick={()=>{

      let newNode = {...node}; // break ref
      newNode.content = definition.id//store section id in content since it's unused by sections

      onSelect&&onSelect(newNode);
      
    }}
    
    
    >Edit Section</button>
    <button className="publish-button nested"
    onClick={()=>{
      OpenSaveAsSectionMenu(definition.content,siteData,definition.id,SectionSaveType.EditCategories,definition.categoryID,()=>{
        templateParams.reload();
      });
      delayedClose();
    }}
    >Edit Section Settings</button>
    <button className="publish-button nested" onClick={duplicate} >Duplicate</button>
    <button className="publish-button nested" onClick={togglePrivate} >{definition.isPrivate?"Set Public":"Set Private"}</button>
    <button className="publish-button nested" onClick={onDelete}>Delete</button>


  </div>

}

  </button>

    </div>
    </>
    }
    {!templateParams.isAdminSite&&templateParams.category === customSaveCategory&&
    <div className="template-hover-menu" style={{position:"absolute",top:"8px",right:"8px",color:"none",padding:"0px"}}
    onClick={(e)=>{e.preventDefault();e.stopPropagation(); onDeleteUserTemplate();}}
    >
      <button className="invisible-button center-all" style={{borderRadius:"50%",background:"#ffffff66",height:"28px",width:"28px"}}><DeleteIcon/></button>
    </div>
    
    }


  </RenderSectionTemplate></>
}

function RenderSectionTemplate({node,userContext,children,onSelect,siteData,extraStyling,definition}:{definition:TemplateDefinition,siteData:SiteData,node:LayoutNode,userContext:UserContext,children?:any,onSelect?:(node:LayoutNode)=>void,extraStyling?:any}){
  
  const sectionRef = useRef<HTMLDivElement>(null);

  replaceAllImagesInNode(node,siteData);

const mapObject = {
  index:0
}
  const [height,setHeight] = useState(10);
  useEffect(() => {

    const resizeObserver = new ResizeObserver((entries) => {
      window.requestAnimationFrame(
      onResize
      )
    });
    const onResize = ()=>{
      if(sectionRef.current){
        const rect = sectionRef.current?.getBoundingClientRect();
        if(rect)
          setHeight(rect.height);

      }
    }

    window.addEventListener("resize",onResize);

    if(sectionRef.current){
      resizeObserver.observe(sectionRef.current!);
      const rect = sectionRef.current?.getBoundingClientRect();
      if(rect)
        setHeight(rect.height);

    }

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize",onResize);
    }
  }, [])

  let otherStyling = extraStyling??{};
  

    return (
        <div className={"relative w-full section-template-preview "+(definition.isPrivate?"private":"")} id={definition.id} style={{height:height+"px",minHeight:Math.max(50,height)+"px",maxHeight:height+"px",...otherStyling}} 
          onClick={()=>{
            //since sections don't have "content" store the template id here to use when referencing what template is being updated
           
            onSelect&&onSelect(node);
          }}
        >
          <div className="template-preview-content" ref={sectionRef} style={{position:"absolute",width:widthPerc,transform:"scale("+templateScale.toString()+")",left:leftPerc,top:leftPerc,pointerEvents:"none"}}>
            <RenderNodeRecursive  siteData={siteData} node={node} userContext={userContext} mapIndex={mapObject}/>
          </div>
          {children}
        </div>
    );
}

function ReplaceBGandImageWithMapping(siteData:SiteData,node:LayoutNode,mapIndex:number){

  mapIndex = mapIndex%siteData.siteStyling.imageMapping.length;

  setNodeComponentAttributeValue(node,componentAttributeTypes.multiLocation,"");

  if(siteData.siteStyling.imageMapping.length<=mapIndex){
    return mapIndex;
  }

  let bg = getNodeStyleAttributeValue(node,ScreenSize.Desktop,"backgroundImage");
  let src = getNodeComponentAttributeValue(node,"imageSrc");

  if(bg && !bg.includes("var(--image-")){

      let newBg = siteData.siteStyling.imageMapping[mapIndex];
      setNodeStyleAttributeValue(node,ScreenSize.Desktop,"backgroundImage","url('"+newBg+"')");
      mapIndex++;


    }
  if(src && !src.includes("var(--image-")){
 
      let newSrc = siteData.siteStyling.imageMapping[mapIndex];
      setNodeComponentAttributeValue(node,"imageSrc",newSrc);
      mapIndex++;

  
    }

  return mapIndex;

}

const replaceAllImagesInNode = (node:LayoutNode,siteData:SiteData)=>{

  const pendingList = [node];
  let index = 0;
  while(pendingList.length>0){
    let current = pendingList.pop();
    if(!current)
      continue;
    index = ReplaceBGandImageWithMapping(siteData,current,index);
    for(let i = 0;i<current.children.length;i++){
      pendingList.push(current.children[i]);
    }
  }
}

function RenderNodeRecursive({siteData,node,userContext,mapIndex}:{siteData:SiteData,node:LayoutNode,userContext:UserContext,mapIndex:{index:number}}){
  

  const Comp = GetWBComponentByTypename(node.typename);

  if(!Comp)
      return <></>;

  return <Comp.RenderLayout component={node} screenSize={ScreenSize.Desktop} isEditor={true} userContext={userContext}  >
          {
              node.children.map((child,i)=>{

                  return <RenderNodeRecursive key={i} siteData={siteData} node={child} userContext={userContext} mapIndex={mapIndex}/>
              })
          }

      </Comp.RenderLayout>


}
function SectionCategoryList({onSelect,params}:{onSelect?:(node:LayoutNode)=>void,params:TemplateParams}){

  //extra padding on left for admin users
  const styl = {cursor:"pointer",padding: (params.isAdmin?"10px 8px 10px 32px":"10px 8px"),borderRadius:"3px"}
  const [selected,setSelected]  = useState("");
  const containerRef            = useRef<HTMLDivElement>(null);
  const draggedRef              = useRef<HTMLDivElement>(null);
  const selectedRef             = useRef<string>("");

  const prevOrder = useRef<CategoryDefinition[]>([]);
  const dragInfo = useRef({startRank:-1,id:""});

  const startDrag = (val:string)=>{

    if(val.length<2)
      return;

    dragInfo.current.startRank = params.categories.find((cat)=>cat.id===val)?.rank??-1;



    dragInfo.current.id = val;
    prevOrder.current = [...params.categories];
    setSelected(val);
    selectedRef.current = val;
  }

  const handleDrag = ()=>{

    if(selectedRef.current&&draggedRef.current){

      let bounds = draggedRef.current?.getBoundingClientRect();

      if(bounds){
        let index = -1;
        for(let i = 0;i<params.categories.length;i++){
          if(params.categories[i].id === selectedRef.current){
            index = i;
            break;
          }
        }

        let newIndex = index;

        if(index<0){return;}
    
        if(params.mouseY < bounds.top-10){
          newIndex-=1;
        }
        else if(params.mouseY > bounds.bottom+10){
          newIndex+=1;
        }

        if(newIndex<0)
          newIndex = 0;
        else if(newIndex>=params.categories.length)
          newIndex = params.categories.length-1;

        if(newIndex!=index){
          let temp = params.categories[index];
          params.categories[index] = params.categories[newIndex];
          params.categories[newIndex] = temp;
          params.setCategories([...params.categories]);
        }
      }
    }
  }

  const endDrag = ()=>{


      if(dragInfo.current.id.length<2)
        return;

    let insertAt = 0;
    
    let origIndex = prevOrder.current.findIndex((val)=>val.id===dragInfo.current.id);
    let newIndex = params.categories.findIndex((val)=>val.id===dragInfo.current.id);

    if(origIndex == newIndex){
      setSelected("");
      selectedRef.current = "";
      dragInfo.current.id = "";
      return;
    }

    let dir = 1;
    if(origIndex>newIndex)
      dir = -1;

    for(let i = 0;i<params.categories.length;i++){
      if( params.categories[i].id === dragInfo.current.id){
        let newIndex = i - dir;
        
        if(newIndex<0)
          newIndex = 0;
        else if(newIndex>=params.categories.length)
          newIndex = params.categories.length-1;
        insertAt = params.categories[newIndex].rank;
        
        break;
      }

    }



    params.setIsLoading(true);

    //edge case where all category rankings are equal
    if(dragInfo.current.startRank == insertAt){
      if(origIndex<newIndex)
        insertAt ++;
      else
        insertAt --;
    }

    ChangeCategorySequence(params.userContext,dragInfo.current.id,dragInfo.current.startRank,insertAt,(data:any)=>{
      //reload categories with their new rankings
      params.reload(false);

    },(error:any)=>{

      AlertConfirm("Error changing category sequence");
      params.setCategories([...prevOrder.current]);
      params.setIsLoading(false);
    });

    setSelected("");
    selectedRef.current = "";
    dragInfo.current.id = "";

  


  }

  useEffect(() => {

    window.addEventListener("pointermove",handleDrag);
    window.addEventListener("pointerup",endDrag);

    return () => {
      window.removeEventListener("pointermove",handleDrag);
      window.removeEventListener("pointerup",endDrag);
    }
//eslint-disable-next-line
  }, [])


  let selectedName = "";
  for(let i = 0;i<params.categories.length;i++){
    if(params.categories[i].id === selected){
      selectedName = params.categories[i].name;
      break;
    }
  }


  return <div className="flex-column h-full" style={{width:"192px"}} >
    {
      params.isAdmin&&<style>{
        `
        .section-category-item{
          position:relative;
        }

        .section-category-item .move-category-selector{
          position:absolute;
          left:0px;
          top:0px;
          display:none;
          transition:.2s;
          width:24px;
          height:100%;
        }

        .section-category-item:hover .move-category-selector{
          cursor:move;
          display:flex;
        }
      `   
        }
      </style>

    }

    <div className="h-full flex-column gap-small scrollable" >
      <div
      className=""
      style={{...styl,color:" var(--input-selected-primary)"}}
      onClick={()=>{
        let node = CreateBlankLayoutNode(wBComponentTypeNames.section);
        let column = CreateBlankLayoutNode(wBComponentTypeNames.column);
        node.children.push(column);
        onSelect&&onSelect(node);
      }}
      > Blank Section</div>

      <div style={{borderBottom:"1px solid #c7c7c7",margin:"3px 10px "}}></div>
      <div className="flex-column gap-small relative" ref={containerRef}>
      {
        selected&&<div className="gray-hover" style={{...styl,cursor:"move", position:"fixed",left:containerRef.current?.getBoundingClientRect().left+"px",top:(params.mouseY-16)+"px",zIndex:200,transition:"0",background:"##E7E7E7",width:containerRef.current?.getBoundingClientRect().width+"px"}}>{selectedName}</div>
      }
      
      { (params.allTemplates.length>0||params.isAdmin)&&
        params.categories.map((val,i)=>{



        let dragStyle:any = selected === val.id?{visibility:"hidden",transition:"0"}:{} ;

        return(
          <div
          key = {val.id}
          ref = {val.id===selected?draggedRef:null}
          className={"gray-hover section-category-item " + (params.category===val.id?"selected":"")}
          style={{...styl,...dragStyle}}
          onClick={()=>{
            params.setCategory(val.id);
            params.category = val.id;
            fadeInTemplates();
          }}
          >{val.name}
          {params.isAdmin &&
          <div className="move-category-selector center-all"
          onPointerDown={(e)=>{e.preventDefault();e.stopPropagation();  startDrag(val.id);}}
          
          >
          <HamburgerIcon/> 
          </div>
          }
          
          </div>
      )

        })
      }
    {params.isAdmin&&
    <>


    <div className="relative" style={{borderBottom:"1px solid #c7c7c7 ",margin:"3px 10px "}}>

      {/* <div style={{position:"absolute",left:"53px",top:"-12px",fontSize:"12px",background:"white",padding:"3px"}}>Admin</div> */}
    </div>
      <div
      className={"gray-hover relative section-category-item admin-only " + (params.category===allCategory?"selected":"")}
      style={{...styl}}
      onClick={()=>{
        params.setCategory(allCategory);
        params.category = allCategory;
        fadeInTemplates();
      }}
      >
      {allCategory}
    </div>
    <div
    className={"gray-hover relative section-category-item admin-only " + (params.category===unCatergorizedCategory?"selected":"")}
      style={{...styl}}
      onClick={()=>{
        params.setCategory(unCatergorizedCategory);
        params.category = unCatergorizedCategory;
        fadeInTemplates();
      }}
      >
        {unCatergorizedCategory}
    </div>
    </>
  }
    {!params.isAdminSite&&false&&
    <>
    <div
    className={"gray-hover section-category-item " + (params.category===customSaveCategory?"selected":"")}
      style={{...styl}}
      onClick={()=>{
        params.setCategory(customSaveCategory);
        params.category = customSaveCategory;
        fadeInTemplates();
      }}
      >
        {customSaveCategory}
    </div>
    </>
}
    </div>
    </div>
  </div>

}
function AdminFilterTab(
  {showPublic,showPrivate,setShowPublic,setShowPrivate,filterOpen, setFilterOpen}:
  {showPublic:boolean,showPrivate:boolean,setShowPublic:(val:boolean)=>void,setShowPrivate:(val:boolean)=>void,filterOpen:boolean,setFilterOpen:(val:boolean)=>void}){

  const clickOutside = (e:any)=>{
    if(!e.target.closest(".filter-tab")){
      setFilterOpen(false);
    }
  }

  useEffect(() => {

    window.addEventListener("click",clickOutside);
    return () => {
      window.removeEventListener("click",clickOutside);
    }
//eslint-disable-next-line
  }, [])

 return <div className="filter-tab"  style={{position:"absolute",top:"20px",right:"18px",zIndex:"500"}}>
    <div className="flex-row gap-med center-all cursor-pointer" onClick={()=>setFilterOpen(!filterOpen)}><div style={{fontSize:"16px",fontWeight:600}}>Filter</div> <div style={{fontSize:".8em",marginTop:"-2px"}}><DownCaret/></div> </div>
    {
      filterOpen&&<div className="flex-column" style={{zIndex:250,position:"absolute",minWidth:"100%",top:"100%",right:"-2px",background:"white",borderRadius:"4px",boxShadow:"0 0 10px 10px #00000005",padding:"4px 12px 4px"}}>
        <CheckItem styling={{height:"44px",paddingRight:"40px"}} item="Public" checked={showPublic} onClickFunc={(e)=>{ e.stopPropagation(); setShowPublic(!showPublic)}} />
        <CheckItem styling={{height:"44px",paddingRight:"40px"}} item="Private" checked={showPrivate} onClickFunc={(e)=>{e.stopPropagation(); setShowPrivate(!showPrivate)}} />
      </div>
    }
  </div>

}
function MenuDots(){

  return <svg xmlns="http://www.w3.org/2000/svg" height="1em" fill="currentColor" viewBox="0 0 128 512"><path  d="M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"/></svg>
}

function HamburgerIconOutlined(){

  return (

<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512" fill="currentColor">

  <path  d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"/></svg>
  )
}

function DeleteIcon() {
  return (

      <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 14 16" fill="currentColor">
          <path   d="M12.8594 3.21875C13.2402 3.21875 13.5625 3.54102 13.5625 3.92188C13.5625 4.33203 13.2402 4.625 12.8594 4.625H12.5078L11.8047 14.1465C11.7168 15.1426 10.9258 15.875 9.92969 15.875H4.04102C3.04492 15.875 2.25391 15.1426 2.16602 14.1465L1.46289 4.625H1.14062C0.730469 4.625 0.4375 4.33203 0.4375 3.92188C0.4375 3.54102 0.730469 3.21875 1.14062 3.21875H3.16211L4.24609 1.60742C4.53906 1.16797 5.06641 0.875 5.62305 0.875H8.34766C8.9043 0.875 9.43164 1.16797 9.72461 1.60742L10.8086 3.21875H12.8594ZM5.62305 2.28125C5.53516 2.28125 5.44727 2.33984 5.41797 2.39844L4.86133 3.21875H9.10938L8.55273 2.39844C8.52344 2.33984 8.43555 2.28125 8.34766 2.28125H5.62305ZM11.1016 4.625H2.86914L3.57227 14.0586C3.60156 14.293 3.80664 14.4688 4.04102 14.4688H9.92969C10.1641 14.4688 10.3691 14.293 10.3984 14.0586L11.1016 4.625Z" />
      </svg>
  )

}

